export const formDataCreator = (
  payload: FormData,
  wholesaler: IFarmAddInfo | undefined,
  guid?: string,
) => {
  guid && payload.append('guid', guid);
  wholesaler?.title && payload.append('title', wholesaler?.title);

  wholesaler?.existing && payload.append('existing', wholesaler?.existing);
  wholesaler?.existing_unit &&
    payload.append('existing_unit', wholesaler?.existing_unit);
  wholesaler?.state && payload.append('state', wholesaler?.state);
  wholesaler?.city && payload.append('city', wholesaler?.city);
  wholesaler?.description &&
    payload.append('description', wholesaler?.description);

  payload.append(
    'hide_phone_number',
    `${wholesaler?.hide_phone_number ? true : false}`,
  );
  if (wholesaler?.images && wholesaler?.images?.length > 0) {
    const mainImage = wholesaler.images?.find(x => x.isSelected)?.file;
    if (mainImage) {
      payload.append('main_image', mainImage);
    }
    wholesaler?.images.map(item => payload.append('new_images', item.file));
  }
  if (wholesaler?.deleted_images && wholesaler?.deleted_images?.length > 0) {
    wholesaler?.deleted_images?.map(item =>
      payload.append('deleted_images', item),
    );
  }
  return payload;
};
